import { Skeleton } from '@mantine/core'
import './StatsCounters.css'
import { IconSchool, IconCertificate, IconBooks, IconCircleCheck, IconCircleX, IconTrophy } from '@tabler/icons-react'
import { useContext, useEffect, useState } from 'react'
import AuthContext from '../../../contexts/AuthContext'
import axios from 'axios'

const STATS_DICT = [
    {
        icon: <IconSchool size={22} />,
        label: 'Capacitaciones',
        value: 'academic_unit_amount'
    },
    {
        icon: <IconCertificate size={22} />,
        label: 'Certificados',
        value: "certificates_amount"
    },
    {
        icon: <IconBooks size={22} />,
        label: 'Clases tomadas',
        value: 'lesson_taken'
    },
]



export default function StatsCounters() {

    const URL = `${process.env.REACT_APP_BACKEND_SERVER}campus/users/dashboard-stats`

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { authToken } = useContext(AuthContext);

    useEffect(() => {
        const getData = async () => {
            try {
                setIsLoading(true)
                const { data } = await axios.get(URL, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authToken,
                    }
                })
                setData(data)
            } catch (error) {
                setError(error)
            } finally {
                setIsLoading(false)
            }

        }
        getData()
    }, [authToken])

    if (isLoading) return (
        <div className="statsCounters">
            <div className="statsCounters__row">
                <div className='statsCounters__item'>
                    <Skeleton h='36px' w='180px' animate />
                </div>
                <div className='statsCounters__item'>
                    <Skeleton h='36px' w='150px' animate />
                </div>
                <div className='statsCounters__item'>
                    <Skeleton h='36px' w='220px' animate />
                </div>
            </div>
        </div>)

    if (error) return <></>


    return (
        <div className="statsCounters">
            <div className="statsCounters__row">
                {data && STATS_DICT.map((stat) => {
                    const current_state = data[stat.value]
                    if (current_state === undefined || current_state === null) return null

                    return <div key={stat.label} className="statsCounters__item">
                        <div className="statsCounters__icon">{stat.icon}</div>
                        <span className="statsCounters__value">{current_state}</span>
                        <span className="statsCounters__label">{stat.label}</span>
                    </div>
                })}
            </div>

          
        </div>
    )
}
